'use strict';

customerZone.controller('MigrationController', ['$q', '$scope', '$log', 'ProductService', 'SubscriptionService',
    'BalanceService', 'Session', 'utils', 'config', '$location', '$timeout', 'errorCode', 'OrderService',
    function($q, $scope, $log, ProductService, SubscriptionService, BalanceService, Session, utils, config, $location,
             $timeout, errorCode, OrderService){

        var self = this;

        var POLL_INTERVAL_MSECS = 500;

        self.loading = false;

        var ORDER_STATE = {
            WAIT_FOR_PAYMENT: 'WAIT_FOR_PAYMENT',
            PROCESSING: 'PROCESSING',
            DONE: 'DONE',
            PAYMENT_ERROR: 'PAYMENT_ERROR',
            PAYMENT_CANCELLED: 'PAYMENT_CANCELLED',
            ERROR: 'ERROR'
        };

        self.onError = function(error){
            $log.error('Migration error: ', error);
            self.migration = {error: true};
        };

        self.subscriber = Session.subscriber();

        self.data = {
            product: null,
            account: {
                email: '',
                exists: false
            },
            delivery: {
                useDifferentAddress: true
            },
            newProduct: null,
            initialTopup: null,
            migrated: false
        };

        self.topupOptions = [];
        self.topupRequired = false;
        self.tosLabel = '';

        self.paymentSettingsPage = config.eserviceUrl+'#!/invoices/payment_setup';

        self.migrate = function(password){
            var promise = SubscriptionService.migrateSubscription(self.subscriber.active, self.data.newProduct.id,
                self.data.initialTopup ? self.data.initialTopup.id : undefined,
                self.paymentMethodSelection.getPaymentMethod,
                config.eserviceUrl+'#!/migration?order={ORDER_ID}', password)
                .then(function(order){
                    if (order.paymentUrl){
                        busy.freeze();
                        utils.redirect(order.paymentUrl);
                    }
                    else {
                        // we'll continue the process in full-screen, so remove the small indicator at this point
                        busy.cancel();
                        self.data.product = self.data.newProduct;
                        $location.search('order', order.id);
                    }
                })
                .catch(function(error){
                    if (errorCode.is(error, errorCode.USER_IN_DUNNING)){
                        busy.showError('cannot_migrate_while_user_in_dunning');
                    }
                    if (errorCode.is(error, errorCode.INVALID_CREDENTIALS)){
                        busy.passThrough('incorrect_password');
                    }
                    if (errorCode.is(error, errorCode.SWITCHING_PLANS_TOO_FREQUENTLY)){
                        busy.showError('cannot_change_tariff_plans_that_frequently');
                    }
                    if (errorCode.is(error, errorCode.SECOND_MIGRATION_WITHIN_30_MINUTES)){
                        busy.showError('second_migration_within_30_minutes');
                    }
                    throw error;
                });
            var busy = utils.showBusy(promise, 'subscription_migration_processing');
            return busy.wrappedPromise;
        };

        var goToHome = function(reason){
            if (reason){
                $log.debug(reason);
                utils.showError(reason);
            }
            utils.goToHome();
        };

        function isMigratable(subscriber) {
            if (!subscriber) return false;
            if (subscriber.state !== jim.SubscriberState.enabled) return false;
            if (!subscriber.sim) return false;
            return true;
        }

        var init = function () {

            if (!isMigratable(Session.subscriber())) {
                goToHome(utils.format('migration_impossible_no_current_subscription'));
                return;
            }

            OrderService.getAllOrdersOfType(jim.OrderType.ORDER_A_MIGRATION, Session.subscriber().id)
                .then(function(pendingOrders){

                    if (pendingOrders.length > 0) {
                        pendingOrders.forEach(function(order){
                            if (order.state === jim.OrderState.waiting_for_payment) {
                                utils.showWarn('you_still_have_to_pay_for_your_new_product');
                                $location.path('/my_orders');
                            }
                            else if (order.state === jim.OrderState.review_needed
                                || order.state === jim.OrderState.unknown) {
                                utils.showError();
                            }
                            else {
                                self.orderState = ORDER_STATE.PROCESSING;
                            }
                        });
                        return;
                    }

                    self.data.product = Session.subscriber().product;

                    var newProductId = $location.search().product;
                    var order = $location.search().order;

                    if (order)
                        pollOrderState(order);
                    else if (newProductId)
                        initializeMigration(newProductId);
                    else {
                        $log.debug('User came in without product nor order -- sending him home');
                        utils.goToHome();
                    }
                })
            .catch(function(error){
                $log.error('Failed to check for pending onboardings', error);
            });

        };

        /** Load all info to migrate to the requested product */
        var initializeMigration = function(newProductId) {

            if (self.data.product.id === newProductId){ // customer has this product already.
                goToHome(utils.format('migration_impossible_you_already_have_{productName}',
                    {productName: self.data.product.name}));
                return;
            }

            self.loading = utils.translate('loading_data');

            ProductService.getProduct(newProductId)
                .then(function(product) {

                    self.tosLabel = utils
                        .format('i_agree_to_tos_{tos_href}{privacy_policy_href}{contract_summary_href}', {
                            'tos_href': utils.legalDoc('terms-and-conditions'),
                            'privacy_policy_href': utils.legalDoc('privacy-policy'),
                            'contract_summary_href': utils.legalDoc('contract-summary/'+product.id)
                        });

                    self.data.newProduct = product;
                    if (product.isPrepaid()) {
                        self.topupRequired = true;
                        return loadTopupOptions();
                    }
                }).then(function(){
                    self.loading = false;
                }).catch(function(error){
                    $log.warn('Requested product does not exist', error);
                    utils.showError();
                });
        };

        /**
         * Start polling for the state of the current order
         * @return {boolean} true if there is indeed an order to poll for (postback mode)
         */
        var pollOrderState = function(orderId){
            var getOrderState = function(){
                return SubscriptionService.getOrder(orderId);
            };

            var stopCondition = function(order){
                if (!order.state) return false;
                if (order.state === jim.OrderState.enabled) return true;
            };

            var untilNotWaitingForPayment = function(order){
                if (!order.state) return false;
                if (order.state === jim.OrderState.waiting_for_payment) return false;
                return true;
            };

            self.orderState = ORDER_STATE.WAIT_FOR_PAYMENT;

            utils.poll(getOrderState, untilNotWaitingForPayment, POLL_INTERVAL_MSECS, 10000, 'paying done')
                .then(function(order) {
                    if (order.state === jim.OrderState.cancelled)
                        throw errorCode.wrap(errorCode.PAYMENT_CANCELLED);
                    if (order.state === jim.OrderState.failed)
                        throw  errorCode.wrap(errorCode.PAYMENT_CANCELLED);
                    if (order.state === jim.OrderState.review_needed)
                        throw errorCode.wrap(errorCode.PAYMENT_REQUIRES_REVIEW);
                    self.orderState = ORDER_STATE.PROCESSING;
                    return utils.poll(getOrderState, stopCondition, POLL_INTERVAL_MSECS, 300000,
                        'order processing');
                })
                .then(function(order){
                    self.orderState = ORDER_STATE.DONE;
                    Session.refresh();
                })
                .catch(function(error){
                    self.orderState = undefined;
                    self.error = true;
                    if (errorCode.is(error, errorCode.PAYMENT_CANCELLED))
                        self.orderState = ORDER_STATE.PAYMENT_CANCELLED;
                    else if (error.pollTimeout === 'paying done')
                        self.orderState = ORDER_STATE.PAYMENT_ERROR;
                    else {
                        self.orderState = ORDER_STATE.ERROR;
                        utils.showError();
                        $log.error('Failure during order state poll: ', error);
                    }
                });

            return true;
        };

        self.migrationType = function(){
            if (!self.data.product) return '';
            if (!self.data.newProduct) return '';
            if (self.data.product.isPostpaid() && self.data.newProduct.isPrepaid()) return 'post2pre';
            if (self.data.product.isPrepaid() && self.data.newProduct.isPostpaid()) return 'pre2post';
            if (self.data.product.isPostpaid() && self.data.newProduct.isPostpaid()
                && self.data.product.price > self.data.newProduct.price) return 'downgrade';
            if (self.data.product.isPostpaid() && self.data.newProduct.isPostpaid()
                && self.data.product.price < self.data.newProduct.price) return 'upgrade';
            if (self.data.product.isPostpaid() && self.data.newProduct.isPostpaid()
                && self.data.product.price === self.data.newProduct.price) return 'post2post';
        };

        self.bundleExpiry = function(){
            if (BalanceService.getBalance().bundles.length === 0) return 'noBundles';
            else return 'endOfBundle';
        };

        var loadTopupOptions = function(){
            return ProductService.getTopupProducts()
                .then(function(products){
                    self.topupOptions = products;
                });
        };

        init();

    }]);
